import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useI18n } from "@/i18n";

const KEY = "ni_consent";
const read = () => { try { return localStorage.getItem(KEY); } catch (e) { return null; } };

export const openCookieSettings = () => window.dispatchEvent(new Event("ni-open-consent"));

export function CookieConsent() {
  const { t } = useI18n();
  const [open, setOpen] = useState(() => !read());
  useEffect(() => {
    const h = () => setOpen(true);
    window.addEventListener("ni-open-consent", h);
    return () => window.removeEventListener("ni-open-consent", h);
  }, []);
  const decide = (v) => {
    try { localStorage.setItem(KEY, v); } catch (e) { /* storage unavailable */ }
    const g = v === "granted" ? "granted" : "denied";
    if (window.gtag) window.gtag("consent", "update", { analytics_storage: g, ad_storage: g, ad_user_data: g, ad_personalization: g });
    if (g === "denied") {
      const parts = window.location.hostname.split(".");
      const domains = parts.map((_, i) => parts.slice(i).join(".")).filter((d) => d.includes("."));
      document.cookie.split(";").map((c) => c.split("=")[0].trim()).filter((n) => n.startsWith("_ga")).forEach((n) => {
        document.cookie = `${n}=; Max-Age=0; path=/`;
        domains.forEach((d) => { document.cookie = `${n}=; Max-Age=0; path=/; domain=.${d}`; });
      });
    }
    setOpen(false);
  };
  if (!open) return null;
  return (
    <div data-testid="cookie-consent-banner" role="dialog" aria-live="polite"
      className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:start-6 sm:max-w-md z-[60] rounded-2xl bg-[#0d0f16]/95 backdrop-blur-xl ring-1 ring-violet-500/40 shadow-2xl p-5 text-slate-100 animate-in fade-in slide-in-from-bottom-4 duration-300">
      <div className="flex gap-3">
        <Cookie size={22} className="shrink-0 text-violet-400 mt-0.5" />
        <p data-testid="cookie-consent-text" className="text-sm leading-relaxed text-slate-300">
          {t("consent.text")}{" "}
          <Link to="/privacy-policy" data-testid="cookie-consent-privacy-link" className="text-violet-300 underline underline-offset-2 hover:text-white">{t("footer.privacy")}</Link>
        </p>
      </div>
      <div className="mt-4 flex justify-end gap-2">
        <button data-testid="cookie-consent-reject" onClick={() => decide("denied")} className="px-4 py-2 rounded-full text-sm font-semibold ring-1 ring-white/20 hover:bg-white/10 transition-colors">{t("consent.reject")}</button>
        <button data-testid="cookie-consent-accept" onClick={() => decide("granted")} className="px-5 py-2 rounded-full text-sm font-semibold bg-violet-600 hover:bg-violet-500 transition-colors">{t("consent.accept")}</button>
      </div>
    </div>
  );
}
